export default __webpack_public_path__ + "static/media/andean1.1c8f9785.jpg";